var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:minimize-fill",
    clipPath: "url(#clip0_707_874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0835 10C2.0835 9.66848 2.21519 9.35054 2.44961 9.11612C2.68403 8.8817 3.00198 8.75 3.3335 8.75H16.6668C16.9984 8.75 17.3163 8.8817 17.5507 9.11612C17.7851 9.35054 17.9168 9.66848 17.9168 10C17.9168 10.3315 17.7851 10.6495 17.5507 10.8839C17.3163 11.1183 16.9984 11.25 16.6668 11.25H3.3335C3.00198 11.25 2.68403 11.1183 2.44961 10.8839C2.21519 10.6495 2.0835 10.3315 2.0835 10Z",
    fill: "white",
    fillOpacity: 0.7
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.a6d4ca57d65aef64f9eee6c97db3e4c1.svg";
export { ForwardRef as ReactComponent };